export default __webpack_public_path__ + "static/media/excellence.ec8211c2.webp";